import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from './Checkbox.js';
export function CheckboxGroup(props) {
    const { options, value, onChange, columns = 2, className, idPrefix = 'cg' } = props;
    const set = new Set(value);
    return (_jsx("div", { className: className, "data-checkbox-group": true, role: "group", style: {
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
            gap: 'var(--space-2)',
        }, children: options.map((opt) => (_jsx(Checkbox, { id: `${idPrefix}-${opt.value}`, label: opt.label, description: opt.description, checked: set.has(opt.value), disabled: opt.disabled, onChange: (e) => {
                const next = new Set(value);
                if (e.target.checked)
                    next.add(opt.value);
                else
                    next.delete(opt.value);
                onChange([...next]);
            } }, opt.value))) }));
}
//# sourceMappingURL=CheckboxGroup.js.map